/**
 * Phone numbers on user accounts (issue #5). The pattern mirrors
 * `App\Entity\User::UK_PHONE_PATTERN` on the API, so a surface can say what is
 * wrong before the round trip and get the same answer the API would give.
 */

/** A UK number in international form: +44 followed by digits. */
export const UK_PHONE_PATTERN = /^\+44[0-9]+$/

/**
 * People write numbers the way they dial them, so what is typed is normalised
 * rather than refused: the spacing comes off, `00` (the international access
 * code) becomes `+`, and a lone leading `0` becomes `+44`. `07700 900123`,
 * `00447700900123` and `+447700900123` are the same number; all come out as the
 * last, which is the form the API stores. This mirrors `User::setPhone()`.
 */
export function normalisePhone(value: string): string {
  const compact = value.replace(/\s+/g, '')

  if (compact.startsWith('00')) return `+${compact.slice(2)}`
  if (compact.startsWith('0')) return `+44${compact.slice(1)}`

  return compact
}

export function isUkPhone(value: string): boolean {
  return UK_PHONE_PATTERN.test(normalisePhone(value))
}
